import { createVuetify } from 'vuetify'
import colors from 'vuetify/util/colors'

import { getInitialTheme } from '../config/theme.js'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

const defaultTheme = {
  defaultTheme: getInitialTheme(),
  themes: {
    dark: {
      colors: {
        primary: colors.purple.lighten1,
        secondary: colors.blue.lighten1,
      },
      dark: true,
    },
    light: {
      colors: {
        primary: colors.purple.darken1,
        secondary: colors.blue.darken1,
      },
      dark: false,
    },
  },
}

export function createXappVuetify(options = {}) {
  const { theme = {}, ...rest } = options
  return createVuetify({
    ...rest,
    theme: deepMerge(defaultTheme, theme),
  })
}

function deepMerge(base, override) {
  if (!isObject(base) || !isObject(override)) {
    return override === undefined ? base : override
  }

  const merged = { ...base }
  for (const [key, value] of Object.entries(override)) {
    const existing = merged[key]
    merged[key] =
      isObject(existing) && isObject(value) ? deepMerge(existing, value) : value
  }
  return merged
}

function isObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value)
}
